import SocialShares from "@/front/components/blog/SocialShares";
import RelatedPosts from "@/front/components/blog/RelatedPosts";
import RestezBranche from "@/front/components/blog/RestezBranche";
import AssuranceStickyCTA from "@/front/components/blog/AssuranceStickyCTA";

let socialMounted = false
document.addEventListener('g2rScroll', function (event) {
  if (event.detail > 200 && !socialMounted && window.innerWidth >= 1024) {
    Vue.prototype.$window = window
    new Vue({
      el: '.social',
      render: h => h(SocialShares)
    });
    socialMounted = true
  }
})

const rlp = document.getElementById('related-posts');
if (null !== rlp) {
  let relatedPostsMounted = false
  document.addEventListener('g2rScroll', function (event) {
    if (event.detail > 300 && !relatedPostsMounted) {
      new Vue({
        el: '#related-posts',
        render: h => h(RelatedPosts)
      })
      relatedPostsMounted = true
    }
  })
}

new Vue({
  el: '#restez-branches',
  render: h => h(RestezBranche)
});

const assuranceStickyCta = document.getElementById('assurance_sticky_cta')
if (null !== assuranceStickyCta) {
  new Vue({
    el: '#assurance_sticky_cta',
    render: h => h(AssuranceStickyCTA)
  })
}
